function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import "./SelectValueList.css";
import classNames from 'classnames';
import memoize from 'memoizee';
import Checkbox from "./Checkbox.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Select values from a long scrollable list.
 * Swaps items in and out for infinite scrolling
 */
class SelectValueList extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "list", void 0);
    _defineProperty(this, "topRow", void 0);
    _defineProperty(this, "bottomRow", void 0);
    _defineProperty(this, "getCachedItem", memoize((itemIndex, key, value, displayValue, rowHeight, isSelected, disabled) => {
      var style = {
        height: rowHeight
      };
      var text = displayValue != null ? displayValue : "".concat(value);
      return (
        /*#__PURE__*/
        // Tab index is needed so the item could be a related target in the blur event details
        _jsx("li", {
          className: "value-list-item",
          style: style,
          tabIndex: -1,
          children: /*#__PURE__*/_jsx(Checkbox, {
            checked: isSelected,
            disabled: disabled,
            onChange: () => this.handleSelect(itemIndex),
            children: text
          })
        }, key)
      );
    }, {
      max: 1000
    }));
    _defineProperty(this, "getCachedItems", memoize((items, rowHeight, offset, disabled) => {
      var itemElements = [];
      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        var value = item.value,
          displayValue = item.displayValue,
          isSelected = item.isSelected;
        var itemIndex = offset + i;
        var key = itemIndex;
        var element = this.getCachedItem(itemIndex, key, value, displayValue, rowHeight, isSelected, disabled);
        itemElements.push(element);
      }
      return itemElements;
    }, {
      max: 1
    }));
    this.handleBlur = this.handleBlur.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.list = /*#__PURE__*/React.createRef();
    this.topRow = null;
    this.bottomRow = null;
  }
  componentDidMount() {
    this.sendViewportUpdate();
  }
  componentDidUpdate() {
    this.sendViewportUpdate();
  }
  handleBlur(e) {
    if (!e.relatedTarget || this.list.current && e.relatedTarget instanceof HTMLElement && !this.list.current.contains(e.relatedTarget)) {
      // Next focused element is outside of the list
      var onBlur = this.props.onBlur;
      onBlur === null || onBlur === void 0 || onBlur(e);
    }
  }
  handleScroll() {
    this.sendViewportUpdate();
  }
  handleSelect(itemIndex) {
    var _this$props = this.props,
      items = _this$props.items,
      offset = _this$props.offset,
      onSelect = _this$props.onSelect;
    var visibleItemIndex = itemIndex - offset;
    if (visibleItemIndex >= 0 && visibleItemIndex < items.length) {
      var item = items[visibleItemIndex];
      var value = item.value;
      onSelect(itemIndex, value);
    } else {
      onSelect(itemIndex, null);
    }
  }
  sendViewportUpdate() {
    if (!this.list.current || this.list.current.clientHeight === 0) {
      return;
    }
    var _this$props2 = this.props,
      onViewportChange = _this$props2.onViewportChange,
      rowHeight = _this$props2.rowHeight;
    var top = this.list.current.scrollTop;
    var bottom = top + this.list.current.clientHeight;
    var topRow = Math.floor(top / rowHeight);
    var bottomRow = Math.ceil(bottom / rowHeight);
    if (this.topRow !== topRow || this.bottomRow !== bottomRow) {
      this.topRow = topRow;
      this.bottomRow = bottomRow;
      onViewportChange(topRow, bottomRow);
    }
  }
  getElement(itemIndex) {
    if (this.list.current == null) {
      return null;
    }
    var elements = this.list.current.querySelectorAll('.value-list-item');
    return elements[itemIndex];
  }
  scrollIntoView(index) {
    var element = this.getElement(index);
    element === null || element === void 0 || element.scrollIntoView({
      block: 'center'
    });
  }
  render() {
    var _this$props3 = this.props,
      className = _this$props3.className,
      disabled = _this$props3.disabled,
      isInvalid = _this$props3.isInvalid,
      items = _this$props3.items,
      itemCount = _this$props3.itemCount,
      offset = _this$props3.offset,
      rowHeight = _this$props3.rowHeight,
      dataTestId = _this$props3['data-testid'];
    var itemElements = this.getCachedItems(items, rowHeight, offset, disabled);
    return /*#__PURE__*/_jsx("div", {
      className: classNames('select-value-list-scroll-pane h-100 w-100', {
        'is-invalid': isInvalid
      }, className),
      onBlur: this.handleBlur,
      onScroll: this.handleScroll,
      ref: this.list,
      "data-testid": dataTestId,
      children: /*#__PURE__*/_jsx("div", {
        className: "select-value-list",
        style: {
          height: itemCount * rowHeight
        },
        children: /*#__PURE__*/_jsx("ol", {
          className: "select-value-list-content",
          style: {
            position: 'absolute',
            height: items.length * rowHeight,
            top: offset * rowHeight,
            left: 0
          },
          children: itemElements
        })
      })
    });
  }
}
_defineProperty(SelectValueList, "defaultProps", {
  disabled: false,
  rowHeight: 21,
  onBlur: () => undefined,
  'data-testid': undefined
});
export default SelectValueList;
//# sourceMappingURL=SelectValueList.js.map